import { useRouteMatch } from 'react-router';
import ContentDetails from './content-details';

export function ContentDetailsView() {
  const { params } = useRouteMatch<{ id: string; feedItemId: string }>();
  return (
    <ContentDetails contentId={params.id} feedItemId={params.feedItemId} />
  );
}
